import { render, staticRenderFns } from "./ListTableFile.vue?vue&type=template&id=3da1da84&scoped=true&"
import script from "./ListTableFile.vue?vue&type=script&lang=js&"
export * from "./ListTableFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da1da84",
  null
  
)

export default component.exports